import { AUTHOR_TYPES } from "../../constants";

export const isAuthorBot = (role: AUTHOR_TYPES): boolean =>
  role === AUTHOR_TYPES.BOT;

export const isAuthorUser = (role: AUTHOR_TYPES): boolean =>
  role === AUTHOR_TYPES.USER;

export const isAuthorOpponent = (role: AUTHOR_TYPES): boolean =>
  role === AUTHOR_TYPES.OPPONENT;
